import React, { useEffect } from "react";
import InvoiceCard from "./common/InvoiceCard";
import Footer from "./Footer";
import HeaderInner from "./HeaderInner";
import configureStore from "../../../store/configureStore";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../common/Loader";
import { get_sales_return } from "./actions/action-salesReturn";
import CommonSnackBar from "../../common/CommonSnackBar";
import { history } from "../../../reducers";
import AddIcon from "@material-ui/icons/Add";
import SalesReturnCard from "./common/SalesReturnCard";

const store = configureStore();

function SalesReturnList() {
  const dispatch = useDispatch();
  const { activeOuid } = store.getState().permission;
  const { salesReturn, showGlobalLoader } = useSelector(
    (state) => state.salesReturn
  );

  function renderList(salesReturn) {
    if (salesReturn) {
      return salesReturn.map((item) => (
        <SalesReturnCard key={item.id} item={item} />
      ));
    } else {
      return <>No sales Return found</>;
    }
  }

  useEffect(() => {
    console.log("inuseEffect");
    const fetchData = async (dispatch) => {
      await dispatch(get_sales_return(activeOuid));
    };
    fetchData(dispatch);
  }, [dispatch]);

  return (
    <div>
      <HeaderInner pageTitle="Sales Returns " />
      <div className=" HrmAppPage container--narrow mt FBAppPage">
        {showGlobalLoader ? <Loader /> : renderList(salesReturn)}

        <div className="AppFloatingButtonWrapper t-r">
          <button
            className="round_btn bg_blue "
            onClick={() => history.push(`/${activeOuid}/create-sales-return`)}
          >
            <AddIcon />
          </button>
        </div>
      </div>
      <Footer />
      <CommonSnackBar />
    </div>
  );
}

export default SalesReturnList;
